import type { GroupChannel } from '@sendbird/chat/groupChannel';
import { GroupChannelListItem } from '@sendbird/uikit-react/GroupChannelList/components/GroupChannelListItem';
import { useGroupChannelListContext } from '@sendbird/uikit-react/GroupChannelList/context';
import React from 'react';

interface ChannelPreviewProps {
    channel: GroupChannel;
}

export const ChannelPreview = ({ channel }: ChannelPreviewProps) => {
    const { selectedChannelUrl } = useGroupChannelListContext();

    return (
        <GroupChannelListItem
            key={channel?.url}
            channel={channel}
            isSelected={channel?.url === selectedChannelUrl}
            tabIndex={0} // Tab functionality not working, but tabIndex is a required prop.
            onClick={() => {}} // onClick is handler by Sendbird's parent ChannelListUI component.
            renderChannelAction={() => <></>} // Disable the channel action context menu, which currently only supports leaving a channel.
        />
    );
};
